import ISOCodeCountry from 'utils/constants/ISOCodeCountry';

export const COUNTRY_OPTIONS = ISOCodeCountry.map(({ code, name }) => ({
  label: name,
  value: code,
}));
